import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RecuperarSenha } from '@/features/login/page/RecuperarSenha';

export const Route = createFileRoute('/auth/recuperar-senha')({
    component: RecuperarSenha,
    validateSearch: z.object({ encode: z.string().optional() }),
});
